import { Injectable } from '@angular/core';
import { AutoRedactionJob } from '../models/auto-redaction-job.model';
import { AutoRedactionRule } from '../models/auto-redaction-rule.model';

@Injectable({
  providedIn: 'root'
})
export class ODataModelSanitizerService {
  sanitize<T>(model: T): T {
    if (model['@odata.etag']) {
      delete model['@odata.etag'];
    }
    if (model['@odata.context']) {
      delete model['@odata.context'];
    }
    return model;
  }

  sanitizeJob(model: AutoRedactionJob): AutoRedactionJob {
    this.sanitize(model);
    if(model.autoRedactionRules)
      model.autoRedactionRules.forEach(r => this.sanitizeRule(r));
    return model;
  }

  sanitizeRule(model: AutoRedactionRule): AutoRedactionRule {
    this.sanitize(model);
    //OData cannot handle a rule with a null 'redactions' field
    if(model['redactions'] !== undefined && model['redactions'] === null)
        delete model['redactions'];
    return model;
  }
}
